import { Link } from "react-router-dom";
import type { Post } from "@/types/content";
import { topics } from "@/mocks/topics";

function categoryName(slug: string) {
  return topics.find((t) => t.slug === slug)?.name ?? "讨论";
}

export default function PostCard({ post }: { post: Post }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/post/${post.id}`} className="block">
        <div className="relative h-44 w-full overflow-hidden bg-background-200 md:h-48">
          <img
            src={post.cover}
            alt={`${post.title} - ${categoryName(post.category)}话题配图`}
            title={`${post.title} 高校吃瓜网`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-medium text-primary-700">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-price-tag-3-line"></i>
            </span>
            {categoryName(post.category)}
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-2.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 rounded-md bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-map-pin-2-line"></i>
            </span>
            {post.school}
          </span>
          <span className="flex items-center gap-1">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-time-line"></i>
            </span>
            {post.createdAt}
          </span>
        </div>

        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-[17px]">
          <Link to={`/post/${post.id}`} className="transition-colors hover:text-primary-700">
            {post.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {post.excerpt}
        </p>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5 truncate">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
              <i className="ri-user-3-line text-[11px]"></i>
            </span>
            <span className="truncate">{post.author}</span>
          </span>
          <span className="flex shrink-0 items-center gap-3">
            <span className="flex items-center gap-1">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-thumb-up-line"></i>
              </span>
              {post.likes}
            </span>
            <span className="flex items-center gap-1">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-chat-3-line"></i>
              </span>
              {post.comments}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}